import React from 'react';
import MinigameCenter from '../../components/Minigame/MinigameCenter';
import SportsRight from '../../components/sports/SportsRight';

const Baseball = () => {
    return (
        <div data-v-623d66c4="" className="contents row" style={{flexDirection: "row"}}>
            <MinigameCenter type="baseball"/>
            <SportsRight type="minigame"/>
        </div>
    );
};

export default Baseball;


// WEBPACK FOOTER //
// ./src/containers/minigame/Baseball.js